import { Maybe } from 'graphql/jsutils/Maybe';
import {
  PageFragment,
  ServicePageNavigationFragment,
} from '@business/gql/graphql';
import { getActiveLinkStyle } from '@utils/stringUtils';
import Link from '../Link/Link';
import { cn } from '@ngg/storefront-utils';
import { Heading } from '../Heading/Heading';

export default function SideMenuNavigation({
  navigation,
  locale,
  slug,
}: {
  navigation: Maybe<ServicePageNavigationFragment>;
  locale: string | undefined;
  slug: string;
}) {
  return (
    <div>
      <Heading as="h3" className="text-lg">
        {navigation?.title}
      </Heading>
      <ul className="mt-2 flex flex-col space-y-1.5">
        {navigation?.sublinksCollection?.items?.map((link) => {
          const linkStyle = getActiveLinkStyle(
            link?.internalLink?.slug ?? '',
            slug,
          );

          if (!link?.internalLink) return null;

          return (
            <li className="text-sm" key={link?.sys?.id}>
              <Link
                className={cn(linkStyle, 'hover:underline')}
                locale={locale}
                href={link?.internalLink?.slug ?? '/'}
                target={link?.openInNewTab ? '_blank' : undefined}>
                {link?.title}
              </Link>
              {Boolean(link.sublinksCollection?.items?.length) && (
                <ul className="mt-2 flex flex-col space-y-1.5 pl-4">
                  {link.sublinksCollection?.items.map((sublink) => {
                    if (!sublink) return;
                    const sublinkStyle = getActiveLinkStyle(
                      sublink.internalLink?.slug ?? '',
                      slug,
                    );
                    return (
                      <li key={sublink.sys.id}>
                        <Link
                          className={cn(sublinkStyle, 'hover:underline')}
                          locale={locale}
                          href={sublink.internalLink?.slug ?? '/'}
                          target={sublink.openInNewTab ? '_blank' : undefined}>
                          {sublink.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
